var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 239.64,
    height: 223.586,
    viewBox: "0 0 239.64 223.586",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_21575",
    "data-name": "Grupo 21575",
    transform: "translate(-883.753 -132.158)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_1219",
    "data-name": "Elipse 1219",
    cx: 4.248,
    cy: 4.248,
    rx: 4.248,
    ry: 4.248,
    transform: "translate(914.099 293.722)",
    fill: "none",
    stroke: "#6ed7c5",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_21541",
    "data-name": "Grupo 21541",
    transform: "translate(1072.625 197.079)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9627",
    "data-name": "Trazado 9627",
    d: "M739.433,256.456h5.9l-.862-6.812h-6.358Z",
    transform: "translate(-720.289 -102.553)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9628",
    "data-name": "Trazado 9628",
    d: "M745.546,256.655h-6.722l-1.478-7.647h7.232Zm-6.033-.835H744.6l-.757-5.977h-5.483Z",
    transform: "translate(-720.025 -102.335)",
    fill: "#2a3879"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9629",
    "data-name": "Trazado 9629",
    d: "M738.925,256.322l-.776,5.044a.746.746,0,0,0,.737.859h16.579a.6.6,0,0,0,.267-1.131l-10.45-5.225s-3.179,2.725-6.357.454",
    transform: "translate(-720.298 -104.688)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9630",
    "data-name": "Trazado 9630",
    d: "M714.43,245.535l5.163,2.862,3.645-5.768-5.56-3.083Z",
    transform: "translate(-712.164 -99.089)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9631",
    "data-name": "Trazado 9631",
    d: "M719.441,248.657l-5.87-3.255,3.646-6.723,6.315,3.5Zm-4.741-3.584,4.456,2.471,3.2-5.061-4.8-2.664Z",
    transform: "translate(-711.87 -98.792)",
    fill: "#2a3879"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9632",
    "data-name": "Trazado 9632",
    d: "M714.261,245.569l-3.124,4.035a.745.745,0,0,0,.228,1.108l14.5,8.039a.6.6,0,0,0,.782-.86l-6.606-9.637s-4.1.842-5.779-2.685",
    transform: "translate(-710.981 -101.155)",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9633",
    "data-name": "Trazado 9633",
    d: "M724.313,115.707l10.016,36.878,4.1,50.991h-8.65l-6.9-50.528s-12.295-27.114-5.011-42.593Z",
    transform: "translate(-712.552 -54.808)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9634",
    "data-name": "Trazado 9634",
    d: "M738.65,203.648h-9.467l-6.938-50.828c-.782-1.739-12.172-27.612-4.984-42.888l.228-.483,6.963,5.674.035.129,10.026,36.915,0,.038Zm-8.738-.835h7.833l-4.058-50.5L723.715,115.6l-5.919-4.824c-6.642,15.208,5.113,41.488,5.234,41.754l.034.116Z",
    transform: "translate(-712.323 -54.463)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9635",
    "data-name": "Trazado 9635",
    d: "M730.633,114.273l16.133,38.939-20.488,49.169-9.561-3.186,16.846-45.983s-18.211-21.854-16.846-35.056Z",
    transform: "translate(-712.924 -56.118)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9636",
    "data-name": "Trazado 9636",
    d: "M726.271,202.639l-10.337-3.446.148-.4,16.763-45.758c-1.888-2.3-18.1-22.452-16.786-35.181l.03-.283,14.546-4.057,16.341,39.439-.067.16Zm-9.257-3.966L725.8,201.6l20.272-48.652-15.925-38.436-13.281,3.705c-1.047,12.91,16.6,34.248,16.777,34.463l.154.185Z",
    transform: "translate(-712.68 -55.856)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9637",
    "data-name": "Trazado 9637",
    d: "M733.5,63.024l3.975-8.651S746.044,61,747.358,43.5l-10.139-3.09-5.342,9.939-5.3,8.612Z",
    transform: "translate(-716.33 -30.783)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9638",
    "data-name": "Trazado 9638",
    d: "M733.38,63.356l-7.688-4.506,5.526-8.975,5.492-10.22L747.5,42.941l-.024.333c-.511,6.8-2.176,10.867-4.951,12.1a5.686,5.686,0,0,1-5.178-.643Zm-6.529-4.794,6.155,3.607,4-8.708.416.319c.025.019,2.461,1.859,4.762.83,2.391-1.069,3.92-4.892,4.426-11.066l-9.49-2.892-5.18,9.638Z",
    transform: "translate(-716.027 -30.522)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9639",
    "data-name": "Trazado 9639",
    d: "M739.971,93.511l13.2-10.926s1.821-2.732,3.642-2.277,5.918,4.553,5.918,4.553a4.439,4.439,0,0,1-3.642-.911s-.911,2.276-2.732,1.366L741.792,99.885Z",
    transform: "translate(-720.925 -44.449)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9640",
    "data-name": "Trazado 9640",
    d: "M741.336,100.464l-2.091-7.318,13.368-11.064c.284-.409,2.106-2.885,4.055-2.4,1.88.469,5.685,4.234,6.113,4.663l.552.552-.765.152a5.1,5.1,0,0,1-3.6-.666,2.882,2.882,0,0,1-1.344,1.218,1.978,1.978,0,0,1-1.421-.011ZM740.2,93.441l1.551,5.429,14.28-14.28.269.135a1.237,1.237,0,0,0,1.03.1,2.468,2.468,0,0,0,1.128-1.249l.237-.583.446.444a3.416,3.416,0,0,0,2.393.861c-1.412-1.34-3.883-3.507-5.065-3.8-1.261-.313-2.732,1.411-3.194,2.1l-.081.09Z",
    transform: "translate(-720.677 -44.232)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9641",
    "data-name": "Trazado 9641",
    d: "M781.828,91.238l-10.075,6.37-1-1.522,10.1-6.387a.91.91,0,0,1,.972,1.539",
    transform: "translate(-731.485 -47.64)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9642",
    "data-name": "Trazado 9642",
    d: "M725.445,61.971l5.463,4.553s11.383,16.39,3.187,20.032l.455,13.659H715.542s3.073-10.927,1.253-19.122,5.008-18.666,8.65-19.121",
    transform: "translate(-712.546 -38.177)",
    fill: "#a72054"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9643",
    "data-name": "Trazado 9643",
    d: "M734.347,93.5l-5.463,3.642L738.9,113.99l17.756-11.382s6.374-3.187,6.83-7.74l-5.464,3.187a3.542,3.542,0,0,0,0-3.187L755.29,98.51l-13.2,7.284Z",
    transform: "translate(-717.122 -48.993)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9644",
    "data-name": "Trazado 9644",
    d: "M738.468,114.268l-10.44-17.558,6.15-4.1,7.758,12.322,12.78-7.051,3.032-4.043.327.491a3.287,3.287,0,0,1,.388,2.506l5.225-3.048-.081.815c-.464,4.643-6.563,7.821-7.038,8.062Zm-9.317-17.3,9.593,16.133,17.43-11.171c.058-.029,5.362-2.727,6.436-6.545l-5.883,3.431.627-1.253a3.62,3.62,0,0,0,.284-2.186l-2.362,3.15-.078.044-13.549,7.474-7.721-12.263Z",
    transform: "translate(-716.829 -48.687)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9645",
    "data-name": "Trazado 9645",
    d: "M748.844,41.29s-3.738-1.938-5.1-.65l-2.491,3.381s-1.04-5.349-2.968-3.015c0,0-.9,1.54-.656,2.344,0,0-2.585,3.4-5.435,2.508a9.539,9.539,0,0,1,.805-7.693s-7.886-2.89-2.9-9.651c0,0,4.139-5.193,8.807-1.335a5.906,5.906,0,0,1,1.655,6.957s9.01.8,8.292,7.153",
    transform: "translate(-716.97 -25.754)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_21540",
    "data-name": "Grupo 21540",
    transform: "translate(883.753 132.158)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9654",
    "data-name": "Trazado 9654",
    d: "M470.412,75.55l.124-1.142-1.721-3.442,7.457-4.015,1.343,3.671,1.526,4.168a39.472,39.472,0,0,1-9.752,17.591V84.925Z",
    transform: "translate(-428.041 -22.965)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9655",
    "data-name": "Trazado 9655",
    d: "M468.688,93.124l0-8.554,1.134-10.395-1.846-3.692,8.232-4.433,3.072,8.4-.022.112a40.306,40.306,0,0,1-9.855,17.8Zm.828-8.486V91a39.561,39.561,0,0,0,8.908-16.49l-2.663-7.279-6.682,3.6,1.6,3.191Z",
    transform: "translate(-427.754 -22.656)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9656",
    "data-name": "Trazado 9656",
    d: "M448.839,40.343h-8.325l.415-7.476.139-2.514h7.216l.258,4.662Z",
    transform: "translate(-418.334 -10.411)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9657",
    "data-name": "Trazado 9657",
    d: "M449.049,40.54h-9.2l.6-10.819h8Zm-8.325-.828h7.449l-.508-9.162h-6.432Z",
    transform: "translate(-418.105 -10.194)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9658",
    "data-name": "Trazado 9658",
    d: "M457.876,105.223H423.267l4.971,14.915Z",
    transform: "translate(-412.418 -36.093)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9659",
    "data-name": "Trazado 9659",
    d: "M449.615,15.207l-.064-6.664H442.19v.032h-6.5l-.063,6.663c-1.143-.952-1.59-.056-1.587.317.032,4.665,1.84,3.808,1.84,3.808,2.158,7.932,7.172,7.076,7.172,7.076,1.527-.154,4.71-1.209,6.313-7.109,0,0,1.809.857,1.841-3.807,0-.373-.445-1.269-1.586-.317",
    transform: "translate(-416.111 -2.93)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9660",
    "data-name": "Trazado 9660",
    d: "M442.448,26.661c-1.289,0-5.187-.561-7.084-7.039a1.283,1.283,0,0,1-.728-.2c-.8-.5-1.215-1.874-1.231-4.075a1.212,1.212,0,0,1,.652-1.061,1.147,1.147,0,0,1,.941,0l.06-6.341h6.5l.415-.032h7.772l.06,6.342a1.144,1.144,0,0,1,.941,0,1.211,1.211,0,0,1,.652,1.06c-.016,2.2-.429,3.572-1.231,4.076a1.286,1.286,0,0,1-.728.2c-1.67,5.713-4.818,6.869-6.57,7.046a2.971,2.971,0,0,1-.424.025m-6.518-8.1.13.478c2.035,7.482,6.655,6.786,6.7,6.777,1.6-.162,4.475-1.257,5.984-6.808l.13-.478.447.212a.474.474,0,0,0,.419-.064c.244-.162.813-.814.83-3.372a.4.4,0,0,0-.177-.3c-.143-.068-.416.048-.73.309l-.671.56-.068-7.127h-6.536l-.415.032H435.88l-.068,7.126-.671-.56c-.314-.261-.587-.378-.73-.309a.4.4,0,0,0-.177.305c.017,2.583.595,3.224.842,3.38a.474.474,0,0,0,.406.057Z",
    transform: "translate(-415.895 -2.713)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9661",
    "data-name": "Trazado 9661",
    d: "M450.373,4.407c-1.206-3.871-9.9-3.3-9.9-3.3-.825.127-1.39-.45-1.84-.635-.89-.363-.445,1.142-.445,1.142-.417-1.566-1.446-1.847-1.9-1.46a2.357,2.357,0,0,0-.19,3.427c-1.776-.381-.953,1.459-.953,1.459a4.461,4.461,0,0,0,.479.493c-.55,1.788-.034,5.916-.034,5.916.254,2.539.761,2.412.761,2.412a11.456,11.456,0,0,0,.444-2.221,12.881,12.881,0,0,1,1.5-4.683c3.978,1.29,9.475.748,9.475.748a8.83,8.83,0,0,1,1.142,3.935c.064,1.4.7,1.776.7,1.776,2.6-5.775.761-9.011.761-9.011",
    transform: "translate(-416.426 0.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9662",
    "data-name": "Trazado 9662",
    d: "M425.983,123.85l-7.457,3.442s-4.589,6.118-4.015,7.266,3.633,3.633,4.4,3.251,4.015-5.736,4.015-5.736l5.354-2.677Z",
    transform: "translate(-409.397 -42.482)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9663",
    "data-name": "Trazado 9663",
    d: "M418.514,137.967a4.579,4.579,0,0,1-2.338-1.173,8.934,8.934,0,0,1-2.245-2.342c-.621-1.242,2.629-5.8,4.054-7.7l.063-.084L425.992,123l2.607,6.3-5.592,2.8c-.845,1.388-3.334,5.4-4.122,5.789a.815.815,0,0,1-.371.08m.072-10.635c-2.332,3.121-4.119,6.2-3.912,6.751.553,1.106,3.313,3.177,3.855,3.057a37.072,37.072,0,0,0,3.831-5.575l.062-.1,5.115-2.558-1.982-4.79Z",
    transform: "translate(-409.188 -42.191)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9664",
    "data-name": "Trazado 9664",
    d: "M416.089,75.121l1.069,9.8v7.457a39.47,39.47,0,0,1-9.752-17.591l1.96-5.358.908-2.482,7.457,4.015-1.721,3.442Z",
    transform: "translate(-406.977 -22.965)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9665",
    "data-name": "Trazado 9665",
    d: "M417.348,93.124l-.717-.769a40.31,40.31,0,0,1-9.856-17.8l-.022-.113,3.072-8.4,8.233,4.433-1.846,3.692,1.137,10.44Zm-9.736-18.612A39.56,39.56,0,0,0,416.519,91V84.638l-1.158-10.615,1.6-3.192-6.683-3.6Z",
    transform: "translate(-406.753 -22.656)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9666",
    "data-name": "Trazado 9666",
    d: "M457.636,58.456l-8.414,4.207-2.677-4.78V82.165H421.307V57.5l-2.486,4.971-.33-.18-8.465-4.6L417.1,44.375a5.518,5.518,0,0,1,2.838-2.537L430.2,38.283s4.015,6.118,8.031,0L449,42.14a4.235,4.235,0,0,1,2.261,2.177Z",
    transform: "translate(-407.875 -13.131)",
    fill: "#ea6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9667",
    "data-name": "Trazado 9667",
    d: "M434.41,175.3c-.956.765-5.322.8-5.322-.733s4.4-7.839,4.4-7.839l-.505-1.909-1.215-4.593,5.959-2.235s1.062,3.285,1.9,5.912a6.168,6.168,0,0,1,.524,2.6c-.263,1.23-4.78,8.031-5.736,8.8",
    transform: "translate(-414.414 -54.194)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9668",
    "data-name": "Trazado 9668",
    d: "M431.773,175.945a5.933,5.933,0,0,1-2.4-.426,1.358,1.358,0,0,1-.917-1.234c0-1.522,3.575-6.78,4.363-7.919l-1.769-6.678,6.718-2.52.133.413s1.061,3.287,1.9,5.915a6.135,6.135,0,0,1,.535,2.813c-.288,1.343-4.887,8.237-5.883,9.032a4.855,4.855,0,0,1-2.678.6m.271-15.745,1.674,6.324-.11.158c-1.671,2.4-4.324,6.584-4.324,7.6,0,.181.15.344.447.487a5.885,5.885,0,0,0,4.2-.078c.857-.685,5.336-7.377,5.59-8.558a6.288,6.288,0,0,0-.514-2.389c-.656-2.064-1.452-4.534-1.763-5.5Z",
    transform: "translate(-414.198 -53.912)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1995",
    "data-name": "Rect\\xE1ngulo 1995",
    width: 35.374,
    height: 23.902,
    transform: "translate(8.459 49.34)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9669",
    "data-name": "Trazado 9669",
    d: "M455.2,99.2H419V74.469h36.2Zm-35.374-.829h34.545V75.3H419.827Z",
    transform: "translate(-410.953 -25.544)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9670",
    "data-name": "Trazado 9670",
    d: "M467.11,109.9c-6.079,6.651-36.863,12.96-36.863,12.96l-3.633-7.266s2.42-1.194,6.009-2.922c9.085-4.365,25.649-12.138,29.364-12.566a7.707,7.707,0,0,1,4.651.945c2.753,1.589,4.059,4.923.472,8.849",
    transform: "translate(-413.566 -34.321)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9671",
    "data-name": "Trazado 9671",
    d: "M429.728,123.112l-3.962-7.923.374-.184c.024-.012,2.464-1.216,6.013-2.924,9.413-4.523,25.759-12.174,29.5-12.6a8.142,8.142,0,0,1,4.906,1,5.4,5.4,0,0,1,2.81,3.807c.2,1.26-.035,3.268-2.239,5.68h0c-6.1,6.672-35.824,12.828-37.086,13.086Zm-2.847-7.548,3.3,6.607c3.245-.686,30.735-6.647,36.33-12.769,1.57-1.717,2.272-3.445,2.033-4.994a4.593,4.593,0,0,0-2.406-3.217,7.3,7.3,0,0,0-4.4-.892c-3.616.417-19.867,8.028-29.232,12.527-2.741,1.319-4.819,2.337-5.632,2.736",
    transform: "translate(-413.275 -34.104)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9672",
    "data-name": "Trazado 9672",
    d: "M433.544,142.837l-.367.112-7.09,2.182s-12.811-23.519-14.723-32.888a8.575,8.575,0,0,1,.031-4.04v0c1.525-5.465,9.474-5.508,12.016-2.65,3.059,3.441,10.134,37.286,10.134,37.286",
    transform: "translate(-408.258 -35.561)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9673",
    "data-name": "Trazado 9673",
    d: "M425.668,145.409l-.162-.3c-.524-.963-12.863-23.681-14.766-33a9.082,9.082,0,0,1,.022-4.179l.015-.058a6.5,6.5,0,0,1,5.126-4.592c2.892-.669,6.088.079,7.6,1.778,3.1,3.484,9.94,36.091,10.23,37.476l.077.37Zm-14.08-37.355-.012.043a8.228,8.228,0,0,0-.024,3.846c1.763,8.635,13.033,29.716,14.52,32.474l6.771-2.083c-2.471-11.773-7.624-34.1-9.96-36.726-1.3-1.462-4.22-2.115-6.793-1.521a5.8,5.8,0,0,0-4.5,3.967",
    transform: "translate(-408.041 -35.343)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9674",
    "data-name": "Trazado 9674",
    d: "M422.909,74.818c.143,0,.287-.01.428-.015l-.1.194Z",
    transform: "translate(-412.295 -25.658)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9675",
    "data-name": "Trazado 9675",
    d: "M447.086,92.874a1.051,1.051,0,0,1-.7-1.834,1.933,1.933,0,0,0-.541-.078,1.929,1.929,0,1,0,1.9,1.683,1.045,1.045,0,0,1-.654.229",
    transform: "translate(-419.506 -31.201)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_21542",
    "data-name": "Grupo 21542",
    transform: "translate(16257 -12719.116)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9676",
    "data-name": "Trazado 9676",
    d: "M627,94.847a21.239,21.239,0,0,0-1.979-4.946l1.7-3.958-5.936-5.794-3.958,1.7a19.076,19.076,0,0,0-4.947-1.979l-1.412-4.1h-8.338l-1.555,4.1a21.264,21.264,0,0,0-4.947,1.979l-3.958-1.7-5.794,5.794,1.7,3.958a19.05,19.05,0,0,0-1.979,4.946l-4.1,1.555v8.338l4.1,1.554a21.27,21.27,0,0,0,1.979,4.946l-1.7,3.958,5.936,5.794,3.958-1.7a19.043,19.043,0,0,0,4.947,1.978l1.555,4.1h8.2l1.554-4.1a21.259,21.259,0,0,0,4.947-1.978l3.958,1.7,5.936-5.794-1.7-3.958a19.022,19.022,0,0,0,1.979-4.946l4.1-1.554V96.4Zm-20.775,15.829A10.176,10.176,0,1,1,616.4,100.5a10.134,10.134,0,0,1-10.176,10.176",
    transform: "translate(-15911.104 12886.896)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9677",
    "data-name": "Trazado 9677",
    d: "M610.824,125.945H601.7l-1.594-4.2a19.411,19.411,0,0,1-4.476-1.8l-4.072,1.745-6.589-6.432,1.751-4.084a22.128,22.128,0,0,1-1.8-4.472l-4.208-1.6V95.833l4.2-1.593a19.316,19.316,0,0,1,1.8-4.476l-1.748-4.078,6.439-6.44,4.079,1.748a22.211,22.211,0,0,1,4.473-1.8l1.6-4.208h9.284l1.45,4.2a19.288,19.288,0,0,1,4.463,1.8l4.072-1.745,6.589,6.432-1.751,4.084a22.122,22.122,0,0,1,1.794,4.467l4.351,1.6V105.1l-4.2,1.594a19.569,19.569,0,0,1-1.8,4.476l1.751,4.082-6.589,6.432-4.074-1.745a22.191,22.191,0,0,1-4.472,1.794Zm-8.2-1.348h7.265l1.515-3.992.342-.086a20.73,20.73,0,0,0,4.786-1.916l.287-.157,3.844,1.647,5.282-5.156-1.642-3.834.157-.288a18.189,18.189,0,0,0,1.914-4.775l.081-.351,4-1.517v-7.4l-4.133-1.516-.087-.346a20.721,20.721,0,0,0-1.917-4.787l-.157-.288L625.809,86l-5.283-5.156-3.844,1.647-.287-.157a18.186,18.186,0,0,0-4.774-1.914l-.365-.084-1.379-4h-7.392l-1.514,3.993-.343.086a20.733,20.733,0,0,0-4.787,1.916l-.287.157-3.839-1.645-5.148,5.148,1.645,3.838-.156.288a18.142,18.142,0,0,0-1.914,4.775l-.081.351-4,1.517v7.408l3.992,1.515.086.342a20.719,20.719,0,0,0,1.917,4.786l.156.288-1.642,3.834,5.282,5.156,3.844-1.647.288.157a18.2,18.2,0,0,0,4.775,1.914l.351.081Zm3.491-13.35A10.85,10.85,0,1,1,616.968,100.4a10.862,10.862,0,0,1-10.849,10.849m0-20.351a9.5,9.5,0,1,0,9.5,9.5,9.513,9.513,0,0,0-9.5-9.5",
    transform: "translate(-15911 12887)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_21543",
    "data-name": "Grupo 21543",
    transform: "translate(16268 -12795)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9646",
    "data-name": "Trazado 9646",
    d: "M680.977,159.35c0,8.061-7.154,14.6-15.979,14.6s-15.981-6.534-15.981-14.6,7.154-14.6,15.981-14.6,15.979,6.535,15.979,14.6",
    transform: "translate(-15911 12887)",
    fill: "#27dac5"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_21",
    "data-name": "L\\xEDnea 21",
    y1: 81.086,
    transform: "translate(-15246.002 13037.228)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1991",
    "data-name": "Rect\\xE1ngulo 1991",
    width: 1.332,
    height: 81.086,
    transform: "translate(-15246.668 13037.227)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9647",
    "data-name": "Trazado 9647",
    d: "M689.855,195.027c0,8.061-7.154,14.6-15.979,14.6s-15.981-6.534-15.981-14.6,7.154-14.6,15.981-14.6,15.979,6.535,15.979,14.6",
    transform: "translate(-15911 12887)",
    fill: "#27dac5"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_22",
    "data-name": "L\\xEDnea 22",
    y1: 70.342,
    transform: "translate(-15237.125 13072.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1992",
    "data-name": "Rect\\xE1ngulo 1992",
    width: 1.332,
    height: 70.342,
    transform: "translate(-15237.79 13072.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9648",
    "data-name": "Trazado 9648",
    d: "M696.076,239.389c.018,13.1-11.594,23.73-25.937,23.747s-25.981-10.59-26-23.689a22.034,22.034,0,0,1,3.27-11.558l45.365-.051a22.044,22.044,0,0,1,3.3,11.551",
    transform: "translate(-15911 12887)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9649",
    "data-name": "Trazado 9649",
    d: "M670.106,263.744a27.786,27.786,0,0,1-18.809-7.1,23.162,23.162,0,0,1-7.823-17.192,22.715,22.715,0,0,1,3.353-11.855l.191-.312,46.147-.052.191.311a22.734,22.734,0,0,1,3.386,11.848,23.155,23.155,0,0,1-7.778,17.21,27.78,27.78,0,0,1-18.824,7.146ZM647.8,228.5a21.553,21.553,0,0,0-3,10.95,22,22,0,0,0,7.432,16.333,26.4,26.4,0,0,0,17.868,6.748h.033a26.385,26.385,0,0,0,17.882-6.788,22,22,0,0,0,7.388-16.349,21.556,21.556,0,0,0-3.027-10.944Z",
    transform: "translate(-15911 12887)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_23",
    "data-name": "L\\xEDnea 23",
    x2: 6.659,
    y2: 9.021,
    transform: "translate(-15243.783 13075.135)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9650",
    "data-name": "Trazado 9650",
    d: "M673.323,197.5l-6.658-9.021,1.1-.68,6.658,9.021Z",
    transform: "translate(-15911 12887)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_24",
    "data-name": "L\\xEDnea 24",
    x1: 7.102,
    y2: 8.919,
    transform: "translate(-15237.125 13081.217)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9651",
    "data-name": "Trazado 9651",
    d: "M674.414,203.493l-1.077-.715,7.1-8.919,1.078.715Z",
    transform: "translate(-15911 12887)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_25",
    "data-name": "L\\xEDnea 25",
    x2: 7.103,
    y2: 7.456,
    transform: "translate(-15253.105 13040.674)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9652",
    "data-name": "Trazado 9652",
    d: "M664.495,161.528l-7.1-7.456,1-.8,7.1,7.456Z",
    transform: "translate(-15911 12887)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_26",
    "data-name": "L\\xEDnea 26",
    x1: 7.546,
    y2: 8.311,
    transform: "translate(-15246.003 13046.35)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9653",
    "data-name": "Trazado 9653",
    d: "M665.51,168.049l-1.025-.776,7.546-8.311,1.025.775Z",
    transform: "translate(-15911 12887)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9623",
    "data-name": "Trazado 9623",
    d: "M756.5,54.665l3.268-10.13L770.551,47.8l2.614-9.8",
    transform: "translate(295.335 133.277)",
    fill: "none",
    stroke: "#6ed7c5",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_1218",
    "data-name": "Elipse 1218",
    cx: 4.248,
    cy: 4.248,
    rx: 4.248,
    ry: 4.248,
    transform: "translate(1005.099 171.722)",
    fill: "none",
    stroke: "#6ed7c5",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_21544",
    "data-name": "Grupo 21544",
    transform: "translate(-158 82)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9580",
    "data-name": "Trazado 9580",
    d: "M330.312,1.5h-61.43a1.54,1.54,0,0,0-1.54,1.54V32.268a1.539,1.539,0,0,0,1.54,1.539h6.378v8.13l9.719-8.13h45.334a1.54,1.54,0,0,0,1.54-1.539V3.04a1.54,1.54,0,0,0-1.54-1.54",
    transform: "translate(848.014 110.497)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9581",
    "data-name": "Trazado 9581",
    d: "M273.76,42.1V33.367h-5.848a2.072,2.072,0,0,1-2.07-2.069V2.07A2.072,2.072,0,0,1,267.912,0h61.43a2.072,2.072,0,0,1,2.07,2.07V31.3a2.072,2.072,0,0,1-2.07,2.069H284.2ZM267.912,1.06a1.011,1.011,0,0,0-1.01,1.01V31.3a1.011,1.011,0,0,0,1.01,1.01h6.908v7.526l9-7.526h45.526a1.011,1.011,0,0,0,1.01-1.01V2.07a1.011,1.011,0,0,0-1.01-1.01Z",
    transform: "translate(848.983 111.468)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9582",
    "data-name": "Trazado 9582",
    d: "M291.425,29.532H289.49V24.177a5.226,5.226,0,0,1,10.451,0v2.452h-1.935V24.177a3.29,3.29,0,0,0-6.58,0Z",
    transform: "translate(833.688 99.21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9583",
    "data-name": "Trazado 9583",
    d: "M284.193,54.186v-9.2a.544.544,0,0,1,.544-.544h13.125a.544.544,0,0,1,.544.544v9.2a.544.544,0,0,1-.544.544H284.737a.544.544,0,0,1-.544-.544",
    transform: "translate(837.114 82.721)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9584",
    "data-name": "Trazado 9584",
    d: "M296.892,54.289H283.767a1.075,1.075,0,0,1-1.074-1.074v-9.2a1.075,1.075,0,0,1,1.074-1.074h13.125a1.075,1.075,0,0,1,1.074,1.074v9.2a1.075,1.075,0,0,1-1.074,1.074M283.767,44l-.015,9.213a.015.015,0,0,0,.015.014h13.125l.014-9.213Z",
    transform: "translate(838.083 83.691)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9585",
    "data-name": "Trazado 9585",
    d: "M303.212,53.4a1.394,1.394,0,1,0-2.269,1.085L300.5,57a.355.355,0,0,0,.349.417H302.8a.355.355,0,0,0,.351-.406l-.383-2.6a1.389,1.389,0,0,0,.442-1.018",
    transform: "translate(826.613 77.831)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9586",
    "data-name": "Trazado 9586",
    d: "M336.792,19.1h31.815a.991.991,0,0,1,.991.991v6.2a.991.991,0,0,1-.991.991H336.792a.99.99,0,0,1-.991-.991v-6.2a.991.991,0,0,1,.991-.991",
    transform: "translate(803.731 99.11)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9587",
    "data-name": "Trazado 9587",
    d: "M367.636,26.846H335.821a1.522,1.522,0,0,1-1.52-1.52v-6.2a1.522,1.522,0,0,1,1.52-1.52h31.815a1.522,1.522,0,0,1,1.52,1.52v6.2a1.522,1.522,0,0,1-1.52,1.52m-31.815-8.183a.461.461,0,0,0-.461.461v6.2a.461.461,0,0,0,.461.461h31.815a.461.461,0,0,0,.461-.461v-6.2a.461.461,0,0,0-.461-.461Z",
    transform: "translate(804.704 100.08)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9588",
    "data-name": "Trazado 9588",
    d: "M336.792,52.2h31.815a.991.991,0,0,1,.991.991v6.2a.991.991,0,0,1-.991.991H336.792a.991.991,0,0,1-.991-.991V53.2a.991.991,0,0,1,.991-.991",
    transform: "translate(803.731 77.699)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9589",
    "data-name": "Trazado 9589",
    d: "M367.636,59.948H335.821a1.522,1.522,0,0,1-1.52-1.52v-6.2a1.522,1.522,0,0,1,1.52-1.52h31.815a1.522,1.522,0,0,1,1.52,1.52v6.2a1.522,1.522,0,0,1-1.52,1.52m-31.815-8.183a.461.461,0,0,0-.461.461v6.2a.461.461,0,0,0,.461.461h31.815a.462.462,0,0,0,.461-.461v-6.2a.461.461,0,0,0-.461-.461Z",
    transform: "translate(804.704 78.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9590",
    "data-name": "Trazado 9590",
    d: "M346.6,62.119a1.488,1.488,0,1,1-1.488-1.488,1.488,1.488,0,0,1,1.488,1.488",
    transform: "translate(798.672 72.25)",
    fill: "#27dac5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9591",
    "data-name": "Trazado 9591",
    d: "M360.744,62.119a1.488,1.488,0,1,1-1.488-1.488,1.488,1.488,0,0,1,1.488,1.488",
    transform: "translate(789.524 72.25)",
    fill: "#27dac5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9592",
    "data-name": "Trazado 9592",
    d: "M375.188,62.119a1.488,1.488,0,1,1-1.488-1.488,1.488,1.488,0,0,1,1.488,1.488",
    transform: "translate(780.183 72.25)",
    fill: "#27dac5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9593",
    "data-name": "Trazado 9593",
    d: "M389.632,62.119a1.488,1.488,0,1,1-1.488-1.488,1.488,1.488,0,0,1,1.488,1.488",
    transform: "translate(770.84 72.25)",
    fill: "#27dac5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9594",
    "data-name": "Trazado 9594",
    d: "M404.076,62.119a1.488,1.488,0,1,1-1.488-1.488,1.488,1.488,0,0,1,1.488,1.488",
    transform: "translate(761.496 72.25)",
    fill: "#27dac5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9595",
    "data-name": "Trazado 9595",
    d: "M418.521,62.119a1.488,1.488,0,1,1-1.488-1.488,1.488,1.488,0,0,1,1.488,1.488",
    transform: "translate(752.152 72.25)",
    fill: "#27dac5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile);
export default __webpack_public_path__ + "static/media/user-profile.0c689b43dd179f6113b05f38062ef090.svg";
export { ForwardRef as ReactComponent };